module.exports = __webpack_public_path__ + "static/media/zoo.58c51986.mov";